import API from 'services/api';

export const deleteRatePlan = ({ ratePlanId }: { ratePlanId: string }) => {
  return API.delete(`/api/accommodation/rate-plan/${ratePlanId}`);
};
